<div class="row">
  <div class="col-md-12">
    <mat-card appearance="outlined" class="marB16">
      <div class="float-right"></div>
      <div class="txt_left">
        <h4 class="h3Header GreyDarkest text-1line marB16 padText">Coupled Activity</h4>
      </div>

      <mat-card-content class="clearfix" *ngIf="isCollapsed">
        <form #fparent="ngForm" name="coupledactForm">
          <div *ngIf="selectedCandidate" class="activityCard">
            <div *ngIf="onSuitability" class="activityCard">
              <activity-check-suitability
                [checkSuitabilityDataObj]="checkSuitabilityDataObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [ifCoupled]="ifCoupled"
                (singleformValid)="singleformValid($event)"
              ></activity-check-suitability>
            </div>
            <div *ngIf="onCorrespondence" class="activityCard">
              <activity-correspondence
                [correspondenceDataObj]="correspondenceDataObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [candidateEmails]="candidateEmails"
                [selectedCandidate]="selectedCandidate"
                [ifCoupled]="ifCoupled"
                (singleformValid)="singleformValid($event)"
              ></activity-correspondence>
            </div>
            <div *ngIf="onInterviewSchedule" class="activityCard">
              <activity-scheduleinterview
                [checkInterviewSchDataObj]="checkInterviewSchDataObj"
                [candidateEmails]="candidateEmails"
                [candidateApplicationIds]="candidateApplicationIds"
                [ifCoupled]="ifCoupled"
                [selectedCandidate]="selectedCandidate"
                (singleformValid)="singleformValid($event)"
              ></activity-scheduleinterview>
            </div>
            <div *ngIf="onStatusChangeSchedule" class="activityCard">
              <activity-status-change
                [checkStatusChangeObj]="checkStatusChangeObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [ifCoupled]="ifCoupled"
                (singleformValid)="singleformValid($event)"
                (createdOnValue)="createdOnValue($event)"
                (createdOnValue1)="createdOnValue1($event)"
                (displayReason)="isSelected = $event"
                (reasonlist)="updateReasonlist($event)"
                (activityId)="activityId = $event"
              ></activity-status-change>
            </div>
            <div *ngIf="onHrPanelInterview" class="activityCard">
              <app-activity-hrinterview
                [checkHrPanelInterviewObj]="checkHrPanelInterviewObj"
                [candidateApplicationIds]="candidateApplicationIds"
                (singleformValid)="singleformValid($event)"
              ></app-activity-hrinterview>
            </div>

            <!-- coupled activities -->
            <div *ngIf="onCoupledSuitability" class="activityCard">
              <app-coupled-suitability-activity
                [checkSuitabilityDataObj]="coupledcheckSuitabilityDataObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [ifCoupled]="ifCoupled"
                (coupledformValid)="coupledformValid($event)"
              ></app-coupled-suitability-activity>
            </div>
            <div *ngIf="onCoupledCorrespondence && !hideCoupledCommunicationForSelectedReason()" class="activityCard">
              <app-coupled-correspoandence-activity
                [correspondenceDataObj]="coupledcorrespondenceDataObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [selectedCandidate]="selectedCandidate"
                (refreshCoupledcorres)="refreshCoupledcorres($event)"
                [candidateEmails]="candidateEmails"
                [createdonEdit]="createdonEdit"
                (createdOnValue)="createdOnValue($event)"
                [ifCoupled]="ifCoupled"
                (coupledformValid)="coupledformValid($event)"
                [isSelected]="isSelected"
                [reasonlist]="reasonlist"
                [activityId]="activityId"
              ></app-coupled-correspoandence-activity>
            </div>
            <div *ngIf="onCoupledInterviewSchedule" class="activityCard">
              <app-coupled-schduele-interview-activity
                [checkInterviewSchDataObj]="coupledcheckInterviewSchDataObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [selectedCandidate]="selectedCandidate"
                [interviewFlag]="interviewFlag"
                [candidateEmails]="candidateEmails"
                [ifCoupled]="ifCoupled"
                (coupledformValid)="coupledformValid($event)"
              ></app-coupled-schduele-interview-activity>
            </div>

            <div *ngIf="onCoupledStatusChangeSchedule" class="activityCard">
              <app-coupled-statuschange-activity
                [checkStatusChangeObj]="coupledcheckStatusChangeObj"
                [candidateApplicationIds]="candidateApplicationIds"
                [ifCoupled]="ifCoupled"
                (coupledformValid)="coupledformValid($event)"
              ></app-coupled-statuschange-activity>
            </div>
            <div *ngIf="onHrPanelInterview" class="activityCard">
              <app-coupled-hrpanel-interview-activity
                [checkHrPanelInterviewObj]="coupledcheckHrPanelInterviewObj"
                [candidateApplicationIds]="candidateApplicationIds"
                (coupledformValid)="coupledformValid($event)"
              ></app-coupled-hrpanel-interview-activity>
            </div>
            <!-- second coupled call ends -->
            <div class="row">
              <div class="col-md-2">
                <div class="row nomarLR padTB16" [ngClass]="{ readActivityDisable: data && data.readflag }">
                  <button
                    mat-raised-button
                    class="primary-btn btnfullWdth"
                    #submitBtn
                    name="submitBtn"
                    [disabled]="!formValid"
                    (click)="saveCoupledActivity()"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <a
            href="javascript:void(0)"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
